<template>
  <div class="convention-hall page">
    <van-nav-bar class="nav-bar" :title="$t('foorter.female')" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#000" size="22" />
      </template>
    </van-nav-bar>
    <div style="padding-bottom: 40px; background-color: unset; overflow-y: auto; -webkit-overflow-scrolling: touch;">
      <van-tabs
        v-model="activeTab"
        @click="onTabChange"
        title-active-color="#fff"
        :color="'unset'"
        line-width="31px"
      >
        <van-tab
          v-for="(tab, index) in distanceTabs"
          :key="index"
          :title="tab.title"
        >
          <div role="feed" class="van-list">
            <div class="pblBox">
              <div
                style="width: calc(50% - 5px);"
                v-for="item in datalist"
                :key="item.id"
                @click="toDetail(item.id)"
              >
                <div class="releaseItem">
                  <div class="imgBox">
                    <div class="van-image" style="width: 100%; height: 100%;">
                      <img :src="item.img_url" class="van-image__img" />
                    </div>
                    <div class="aaa">
                      <div style="width: 40%; height: 32px; padding-top: 8px; float: left; margin-left: 10px;">
                        <img src="/img/home/xing.png" style="height: 32px; width: 32px; vertical-align: middle;" />
                      </div>
                      <div style="height: 26px; float: right; margin-right: 0px; line-height: 26px; font-size: 12px; background: linear-gradient(90deg, rgb(252, 120, 175), rgb(242, 38, 120)); padding-right: 5px; padding-left: 5px; color: rgb(255, 255, 255); text-align: center; border-radius: 0px 0px 0px 10px;">
                        {{ $t('member.same_city') }}
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="infoBox" style="display: none;">
                      <i class="van-icon van-icon-location" style="font-size: 14px;"></i>
                      <span style="font-size: 12px; margin: 0px 0px 0px 2px;"></span>
                      <div class="wantyuebtn">{{ $t('member.i_want_to_book') }}>></div>
                    </div>
                  </div>
                  <div style="width: 100%; margin-top: 4px; height: 32px; line-height: 32px; font-size: 14px; color: rgb(0, 0, 0);">
                    <div style="width: 50%; float: left; margin-left: 2px; text-align: left; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 12px;">
                      <img :src="item.img_url" style="width: 28px; height: 28px; vertical-align: middle; border-radius: 14px;" />
                      {{ item.xuanfei_name }}
                    </div>
                    <div style="width: 38%; float: right; margin-right: 2px; text-align: right; height: 32px; line-height: 32px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      <img src="/img/home/dingwei1.png" style="width: 16px; height: 16px; vertical-align: middle; font-size: 10px;" />
                      {{ item.distance_label }}
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  <div style="width: 100%;">
                    <div class="tags" style="padding-top: 2px; padding-bottom: 2px;"></div>
                  </div>
                  <div style="display: flex; align-items: center; padding: 0px 0px 4px;">
                    <van-rate v-model="item.number" readonly color="#ffd21e" size="20px" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nvai',
  data() {
    return {
      activeTab: 0,
      distanceTabs: [
        { title: this.$t('member.all'), value: 0 },
        { title: this.$t('member.within_3km'), value: 3 },
        { title: this.$t('member.within_5km'), value: 5 },
        { title: this.$t('member.within_10km'), value: 10 },
        { title: this.$t('member.within_15km'), value: 15 },
        { title: this.$t('member.within_30km'), value: 30 },
        { title: this.$t('member.within_50km'), value: 50 },
      ],
      datalist: [],
      gender: 2, // 2=Female
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onTabChange(index) {
      this.activeTab = index;
      this.getMemberList();
    },
    toDetail(id) {
      this.$router.push({ path: '/detail', query: { id: id } });
    },
    getMemberList() {
      const distance = this.distanceTabs[this.activeTab].value;
      this.$http({
        method: 'get',
        url: 'member_list',
        data: { gender: this.gender, distance: distance },
      }).then(res => {
        if (res.code === 200) {
          this.datalist = res.data || [];
          this.datalist.forEach(item => {
            const dist = parseInt(item.distance) || 0;
            if (dist <= 3) item.distance_label = this.$t('member.within_3km');
            else if (dist <= 5) item.distance_label = this.$t('member.within_5km');
            else if (dist <= 10) item.distance_label = this.$t('member.within_10km');
            else if (dist <= 15) item.distance_label = this.$t('member.within_15km');
            else if (dist <= 30) item.distance_label = this.$t('member.within_30km');
            else item.distance_label = this.$t('member.within_50km');
          });
        }
      });
    },
  },
  created() {
    this.getMemberList();
  },
};
</script>

<style lang="less" scoped>
.page {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('/img/home/g.png') center top / 100% repeat;
  background-color: #f5f5f5;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.nav-bar {
  background: unset;
  height: 13.333vw;
  flex-shrink: 0;
}
.van-nav-bar {
  line-height: 6.667vw;
}
::v-deep .van-nav-bar__title {
  max-width: 60%;
  margin: 0 auto;
  color: #000;
  font-size: 4.667vw;
}
::v-deep .van-nav-bar__content {
  height: 13.333vw;
}
::v-deep .van-tab--active {
  background: linear-gradient(90deg, rgb(252, 120, 175), rgb(242, 38, 120));
  color: rgb(255, 255, 255);
  border-radius: 2.667vw;
}
::v-deep .van-tab {
  font-size: 4vw;
  line-height: 9.333vw;
  font-weight: 700;
  flex: 1 0 auto;
}
::v-deep .van-tabs__line {
  background-color: unset;
}
::v-deep .van-tabs--line .van-tabs__wrap {
  height: 9.333vw;
}
::v-deep .van-tabs__wrap--scrollable .van-tab {
  padding: 0 3.067vw;
}
::v-deep .van-tabs__nav {
  background: unset;
}
.convention-hall {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.pblBox {
  display: flex;
  justify-content: space-between;
  padding: 2.667vw 5.333vw;
  flex-wrap: wrap;
}
.releaseItem {
  width: 100%;
  margin-bottom: 4vw;
}
.releaseItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 1.067vw;
  height: 42.667vw;
}
.tags {
  display: flex;
  margin: 0 0 0.533vw;
  flex-wrap: wrap;
}
.tags .van-tag {
  padding: 2vw 1.333vw;
  font-size: 2.667vw;
  margin: 0 0.8vw 0.267vw 0;
  border-radius: 2.133vw;
}
.releaseItem .imgBox .aaa,
.releaseItem .imgBox span {
  position: absolute;
  z-index: 9;
  height: 6.933vw;
  width: 100%;
  top: 0;
}
.releaseItem .imgBox .infoBox {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  color: #fff;
  width: 100%;
  height: 8vw;
  padding: 0 2.667vw;
}
.releaseItem .imgBox .infoBox .wantyuebtn {
  border: 0.267vw solid #fff;
  padding: 1.333vw 2.133vw;
  border-radius: 2.133vw;
  opacity: 0.9;
  font-size: 3vw;
  margin-left: auto;
}
</style>
